module.exports = __webpack_public_path__ + "img/BlueOutline640.b68f247f.png";